import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-resource_2group1",
  "use": "icon-resource_2group1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-resource_2group1\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M20,9.58H4V5.45c0-.46.36-1.18.8-1.18h5.93l1.6,2H19.2a.82.82,0,0,1,.8.83Zm0,1.65v7.68a.81.81,0,0,1-.8.82H4.8a.81.81,0,0,1-.8-.82V11.23Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol